import { crudApi } from "../../../helpers/api_helper";
import { CONDICAO_PAGAMENTO } from "../../../helpers/url_helper";

export default crudApi(CONDICAO_PAGAMENTO);